import { Component, OnInit } from '@angular/core';
import { ChangeDetectionStrategy, ViewChild } from '@angular/core';

import cloneDeep from 'lodash/cloneDeep';
import { NbTreeGridDataSource, NbTreeGridDataSourceBuilder, NbToastrService, NbDialogService } from '@nebular/theme';
import { FormControl, NgForm } from '@angular/forms';
import { NbSearchService, NbAccordionItemComponent, NbMenuService, NbDatepickerModule } from '@nebular/theme';
import { DashService } from '../dash.service';
import { Subscription } from 'rxjs'
import { Subject } from 'rxjs';
import { HttpClient } from '@angular/common/http'
import { EnvService } from '../../env.service';
import { liveSearch } from '../dash.operator';
import { Router, NavigationStart, ActivatedRoute } from '@angular/router';
import { Injectable } from '@angular/core';
import {Inject} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { UserVerificationDialog } from 'src/app/verifyAuth/verify.component';
import { HubStatusDialog } from '../hubStatusDialog/hubStatus.component';
import consoleCommands from '../../../../backend/resources/consoleCommands.js';
import { HubHistoryComponent } from '../dialog/hub-history/hub-history.component';
import { NodeHistoryComponent } from '../dialog/node-history/node-history.component';
import { CountdownTimerComponent } from '../dialog/countdown-timer/countdown-timer.component';
import * as moment from 'moment';
import { releasedNodeTypes } from 'src/app/releasedNodeTypes';
import { PasswordDialogComponent } from 'src/app/password-dialog/password-dialog.component';
import { ConfirmDialogComponent } from 'src/app/confirm-dialog/confirm-dialog.component';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { ViewportScroller } from '@angular/common';

interface TreeNode<T> {
  data: T;
  children?: TreeNode<T>[];
  expanded?: boolean;
}

interface FSEntry {
  name: string;
  size: string;
  kind: string;
  items?: number;
}
@Component({
  selector: 'app-user-detail',
  templateUrl: './user-detail.component.html',
  styleUrls: ['./user-detail.component.css']
})
@Injectable({ providedIn: 'root' })
export class UserDetailComponent implements OnInit {

  private searchSubject = new Subject<string>();
  private searchSubscription: any;

  private searchSubjectSmall = new Subject<{value:string,hub:any}>();
  private searchSubscriptionSmall: any;

  //{title:'Verify Email'},
  items = [{title:"Transfer Hubs"},{title:"Resync Voice Assistants"},{title:"Ask Store Rating"}]
  private dashDataSub: Subscription;
  customColumn = 'Parameter';
  defaultColumns = ['This week', 'Last week', 'Growth (%)'];
  allColumns = [this.customColumn,'This week', 'Last week', 'Growth (%)'];
  selectedComparePeriod = "Daily";
  value = '';
  searchEid = '';
  allHubData = [];
  customersData = {};
  custId = "";
  geoPositions = [];
  totalHubs = 0;
  user = {}
  criticalLogs = {};
  searchValue = '';
  menuServiceSub: Subscription;
  onlyOwned = true;
  showDeletedSNodes = false;
  offlineNodes=[];
  isLoading = false;
  linkedDevices = {yale:[]}

  canBeRepeater = [
        "P_1", // 12
        "S_1", // 13
        "SS_1", // 17
        "P16_1", // 18
        "SSS_1", // 21
        "IWS_GC_1", // 26
        "IWS_16A_1", // 27
        "SSS_2", // 28
        "IWS_2RC_1", // 31
        "IWS_RGB_1", // 32
        "IWS_3D_1", // 34
        "IWS_3RC_1", // 38
        "IWS_1D_1", // 40
        "SS_2", // 43
        "RPTR_1", // 44
        "IWS_3D_2", // 47
        "EM_1", // 48
        "DC_EP_1", // 58
        "IWS_3D_3", // 62
        "IWS_SC_DC_2", // 63
        "SS_3", // 65
        "IWS_16A_2", // 66
        "IWS_MC_3", // 67
        "RPTR_2", // 69
        "IWS_2RC_2", // 70
        "IWS_2D_2", // 71
        "SSS_3", // 72
        "IWS_TD_2", // 73
       "IWS_1D_2", // 74
        "IWS_GC_3", // 79
        "IWS_3RC_2", // 80
        "IWS_SC_AC_2", // 82
        "IWS_TD_1",
        "IWS_TD_2",

        "IWS_3D", //101
        "MSC", // 102
        "IWS_2S", // 104
        "IWS_16A", // 105
        "CC", // 106
        "RPTR", // 108
        "IWS_2RC", // 109
        "IWS_2D", // 110
        "IWS_3S", // 111
        "IWS_TD", // 112
        "IWS_HPD", // 113
        "CCLV", // 114
        "GC", // 117
        "IWS_3RC", // 118
        "DCSC", // 120
        "RGBWW", // 122
        "SWP_4S", // 123
        "SWP_2D", // 124
        "TRKD", // 130
        "SC", // 131
        "SC_ML", //132
        "DALI_SL"
  ]

  onToggle(){
    console.log("toggle change",this.onlyOwned);
    this.fetchCustomerData(this.custId,this.onlyOwned,this.showDeletedSNodes);
  }

  onShowSNodeToggle(){
    console.log("toggle change",this.showDeletedSNodes);
    this.fetchCustomerData(this.custId,this.onlyOwned,this.showDeletedSNodes);
  }

  markerOptions = {
    icon:'../../../images/logo_new.svg'
  }

  //node-search tool functionality
  searchData=[];

  clearFields(hubId,hub){
    this.searchData[hubId]['searchString']="";
    this.onNodeLevelSearch({value:"",hub})
  }

  @ViewChild('debugger') debuggerAccordian;
  today: Date;


  graph = {
    data: [],
    layout: {}
  };
  repeaterGraph = {
    data: {},
    type: "OrgChart"
  }
  readonly position = { lat: 28.644800, lng: 77.216721 };
  showHealthGraph = false;

  dataSource: NbTreeGridDataSource<FSEntry>;

  private userQuerySubject = new Subject<string>();
  private custInfoDataListener = new Subject<boolean>();

  getCustInfoDataListener() {
    return this.custInfoDataListener.asObservable();
  }

  onExpandedChange(checked,hub){
    console.log("onExpandedChange called",checked,hub);
    
    hub.showNodes=checked
  }

  hubSpecificMenu = [
    {
      title: 'Request Access',
      icon: 'person-add-outline',
    },
    {
      title: 'Trigger Support Access Last State',
      icon: 'person-add-outline',
    },
    // {
    //   title: 'Transfer',
    //   icon: 'arrow-forward-outline',
    //   // link: '/hubTransfer',
    // },
    {
      title: 'Replacement',
      icon: 'swap-outline',
      // link: '/hubReplacement'
    },
    {
      title: 'Update-Status',
      icon: 'settings-outline',
      // link: '/hubReplacement'
    },
    {
      title: 'Restart hub',
      icon: 'sync-outline',
      // link: '/sendCommand'
    },
    {
      title: 'Trigger OTA',
      icon: 'cast-outline',
    },
    {
      title: 'Request Health Update',
      icon: 'activity-outline',
    },
    {
      title: 'Auto Configure Repeaters',
      icon: 'options-outline'
    },
    {
      title: 'Realign Network',
      icon: 'shuffle-2-outline'
    },
    {
      title: 'Redownload Network Params',
      icon: 'cloud-download-outline',
    },
    {
      title: 'Change Region',
      icon: 'map-outline',
    },
    {
      title: 'Clean Sync Rules & Scenes',
      icon: 'trash-2-outline',
      // link: '/sendCommand'
    },
    {
      title: 'Sync Rules',
      icon: 'refresh-outline',
      // link: '/sendCommand'
    },
    {
      title: 'Sync Scenes',
      icon: 'refresh-outline',
      // link: '/sendCommand'
    },
    {
      title: 'Remove all Repeaters',
      icon: 'trash-2-outline',
      // link: '/sendCommand'
    },
    // {
    //   title : "Mark as Testing Required HUB",
    //   icon:"checkmark-circle-outline"
    // }
  ]

  nodeSpecificMenu=[
    {
      title: 'Force Remove',
      icon: 'alert-triangle-outline'
    },
    {
      title : "Toggle Repeater",
      icon:"toggle-right-outline"
    },
    {
      title : "Delay Modifier",
      icon:"arrowhead-up-outline"
    },
    {
      title : "Trigger Node OTA",
      icon:"cloud-upload-outline"
    },
    {
      title : "ReSync DALI Parameters",
      icon: 'refresh-outline',
    },
    {
      title : "Delete Lock Users",
      icon:"trash-outline"
    },
    // {
    //   title : "Mark as Testing Required",
    //   icon:"checkmark-circle-outline"
    // }
  ]

  
  // getHubSpecificMenu(hub: Object) {
  //   // console.log(hub)
  //   if(hub['hubStatus'] && hub['hubStatus']['blockFunctionality']) {
  //     hubSpecificMenu.push({
  //       title: 'UNLOCK',
  //       icon: 'toggle-right-outline'
  //     })
  //   } else {
  //     hubSpecificMenu.push({
  //       title: 'LOCK',
  //       icon: 'toggle-left-outline'
  //     })
  //   }
  //   return hubSpecificMenu;
  // }

  searchUsers(query: string) {
    // console.log("search Users: " + query)
    this.userQuerySubject.next(query);
    // this.ngOnInit();
  }

  readonly custDatas$ = this.userQuerySubject.pipe(
    liveSearch(query => this.dashService.fetchUsers(query))
  );

  removeNonAlphaNumeric(str) {
    return str.replace(/[^a-zA-Z0-9@._%+-]/g, "");
  }

  constructor(private viewportScroller:ViewportScroller,private route: ActivatedRoute, public dialog: MatDialog, private router: Router, private http: HttpClient, private env: EnvService, public dashService: DashService, dataSourceBuilder: NbTreeGridDataSourceBuilder<FSEntry>, private searchService: NbSearchService, private toastrService: NbToastrService, private nbMenuService: NbMenuService,private dialogService:NbDialogService) {
    this.searchService.onSearchInput()
      .subscribe((data: any) => {
        this.searchValue = data.term;
        let newTerm = this.removeNonAlphaNumeric(data.term);
        console.log(this.searchValue,"new Term:",newTerm);
        this.searchUsers(newTerm)
      })
    this.router.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    }

    // this.router.events
    //   .subscribe((event: NavigationStart) => {
    //     if (event.navigationTrigger === 'popstate') {
    //       // Perform actions
    //       console.log("back Pressed");
    //       this.router.navigate(['users']);
    //     }
    //   });

    // console.log(this.router.url.split('/'));

    this.dataSource = dataSourceBuilder.create(this.data);
    this.dashDataSub = this.dashService.getdashDataListener().subscribe(
      dashDataStatus => {
        console.log(dashDataStatus);
        this.summary = [
          { title: 'Scenes', value: this.dashService.accountAnalytics["sceneCount"] },
          { title: 'Rules', value: this.dashService.accountAnalytics["ruleCount"] },
          { title: 'Cameras', value: this.dashService.accountAnalytics["cameraCount"] },
          { title: 'Android', value: this.dashService.accountAnalytics["androidInstallations"] },
          { title: 'IOS', value: this.dashService.accountAnalytics["iosInstallations"] }
        ]
        console.log(this.dashService.customersData);
        // this.initializeMapMarkers(this.dashService.customersData);
      }
    );
    this.today =new Date();
  }

  openDialog(): void {
    console.log('open dialog')
    const dialogRef = this.dialog.open(UserVerificationDialog, {
      data: {custId: this.custId}
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
    });
  }

  openHubConfigDialog(hubId): void {
    console.log('triggered hub config dialog')
    const dialogRef = this.dialog.open(HubStatusDialog, {
      data: {custId: this.custId, hubId: hubId, config: this.fetchHubStatus(hubId)}
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
    });
  }

  openHubHistoryDialog(hubId: string){
    let dialogRef=this.dialog.open(HubHistoryComponent, {data : {hubId: hubId}});
    dialogRef.updateSize('90%','90%');
  }

  openNodeHistoryDialog(nodeId: string){
    let dialogRef=this.dialog.open(NodeHistoryComponent, {data : {nodeId: nodeId}});
    dialogRef.updateSize('80%','80%');  
  }

  summary = []

  clearSearchEid(){
    this.searchEid = "";
    this.onSearchEidChange("");
    this.isSearchingByEid=false;
  }

  isSearchingByEid = false;
  showingResultCount = 0;

  removeNonAlphaNumericLean(str) {
    return str.replace(/[^a-zA-Z0-9]/g, "");
  }

  onSearchEidInput(value: string) {
    let newValue = this.removeNonAlphaNumericLean(value);
    this.searchSubject.next(newValue);
    this.clearAutoRefreshLogsForAll();
    this.clearAutoRefreshStatusForAll()
  }

  onSearchEidInputSmall(value: string,hub:any) {
    this.searchSubjectSmall.next({value,hub});
  }

  ngAccordingHeaderClicked(event,key,hub){
    event.preventDefault();
    event.stopImmediatePropagation();
    if(this.customersData["hubs"]){
      for(var i=0;i<this.customersData["hubs"].length;i++){
        if(this.customersData["hubs"][i]["hubId"] == hub.hubId){
          this.customersData["hubs"][i][key] = !this.customersData["hubs"][i][key]
          break
        }
      }
    }
  }

  ngAccordingHeaderClickedForNode(event,key,hub,node){
    event.preventDefault();
    event.stopImmediatePropagation();
    if(this.customersData["hubs"]){
      for(var i=0;i<this.customersData["hubs"].length;i++){
        if(this.customersData["hubs"][i]["hubId"] == hub.hubId){
          if(this.customersData["hubs"][i].nodes) {
            for(var j=0;j<this.customersData["hubs"][i].nodes.length;j++){
              if(this.customersData["hubs"][i].nodes[j].nodeId == node.nodeId){
                this.customersData["hubs"][i].nodes[j][key] = !this.customersData["hubs"][i].nodes[j][key]
                break
              }
            }
          }
        }
      }
    }
  }

  resetShowNodesForAllHubs(){
    if(this.customersData["hubs"]){
      for(var i=0;i<this.customersData["hubs"].length;i++){
        this.customersData["hubs"][i].showNodes = false;
        this.customersData["hubs"][i].showVNs = false;
        this.customersData["hubs"][i].showLocation = false;
      }
    }
  }

  onNodeLevelSearch(obj:{value:string,hub:any}){
    let allHubDataCopy = cloneDeep(this.allHubData);
    let nodesOld = [];
    for(const hubLocal of allHubDataCopy){
      if(obj.hub["hubId"] == hubLocal.hubId ){
        nodesOld = hubLocal.nodes;
        break;
      }
    }
    let newNodes = obj.value == "" ? nodesOld : nodesOld.filter(item=>{
      return item.nodeId.replace(/:/g,"").replace(/-/g,"").toLowerCase().includes(obj.value.replace(/:/g,"").replace(/-/g,"").toLowerCase()) || item.nodeType.replace(/:/g,"").replace(/-/g,"").replace(/_/,"").toLowerCase().includes(obj.value.replace(/:/g,"").replace(/-/g,"").replace(/_/,"").toLowerCase())
    });

    newNodes.forEach(node=>{
      node.graphStart = new Date(node.graphStart);
      node.graphEnd = new Date(node.graphEnd);
    })

    for(var i=0;i<this.customersData["hubs"].length;i++){
      if(this.customersData["hubs"][i].hubId == obj.hub.hubId){
        this.customersData["hubs"][i].nodes = newNodes;
        break
      }
    }
  }

  onSearchEidChange(value){
    //console.log("onSearchEidChange called with ",this.searchEid);
    this.resetShowNodesForAllHubs();
    this.isSearchingByEid = true;
    this.showingResultCount= 0;
    let eid = value.replace(/:/g,"").replace(/-/g,"").replace(/ /g,"").toLowerCase();
    if(eid == "") {
      this.customersData["hubs"] = this.allHubData;
    }else {
      let hubsFinal = [];
      this.customersData["hubs"] = this.allHubData;
      let wasFullMatchWasThere = false;
      for(const hub of this.allHubData) {
        let hubId = hub.hubId.replace(/:/g,"").replace(/-/g,"").toLowerCase();
        if(hubId.includes(eid)) {
          hubsFinal.push(hub);
          wasFullMatchWasThere = true;
          console.log("onSearchEidChange called with ",eid,hubId,wasFullMatchWasThere);
          this.showingResultCount += 1;
        }else {
          if(hub.nodes) {
            let nodes = [];
            let hubNew = JSON.parse(JSON.stringify(hub));
            if(hubNew.graphStart){
              hubNew.graphStart = new Date(hubNew.graphStart)
            }
            if(hubNew.graphEnd){
              hubNew.graphEnd = new Date(hubNew.graphEnd)
            }
            let nodesWereAdded = false;
            for(const node of hub.nodes) {
              let nodeId = node.nodeId.replace(/:/g,"").replace(/-/g,"").toLowerCase();
              if(nodeId.includes(eid)) {
                nodes.push(JSON.parse(JSON.stringify(node)));
                nodesWereAdded = true;
              }
            }
            if(nodes.length <= 0){
              nodes = JSON.parse(JSON.stringify(hubNew.nodes));
            }
            nodes.forEach((node)=>{
              if(node.graphStart){
                node.graphStart = new Date(node.graphStart)
              }
              if(node.graphEnd){
                node.graphEnd = new Date(node.graphEnd)
              }
            })
            hubNew.nodes = nodes;
            if(!wasFullMatchWasThere && nodesWereAdded){
              this.showingResultCount += nodes.length;
              console.log("onSearchEidChange wasFullMatchWasThere is false ",this.showingResultCount);
            }
            if(nodesWereAdded){
              hubsFinal.push(hubNew);
            }
          }
        }
      }
      if(hubsFinal.length <= 0){
        console.log("onSearchEidChange called hubsFinal length is less than 0");
        hubsFinal = this.allHubData;
      }
      console.log("onSearchEidChange called hubs.length",hubsFinal.length);
      this.customersData["hubs"] = hubsFinal;
    }
    
    for(var i=0;i<this.customersData["hubs"].length;i++){
      let hubId = this.customersData['hubs'][i]["hubId"];
      let oldHub = this.allHubData.filter(hub=>{
        return hub.hubId == hubId
      })[0];
      this.customersData['hubs'][i]["nodeCount"] = oldHub.nodes == undefined ? 0 : oldHub.nodes.length
    }
  }

  ngOnInit(): void {
    console.log(history.state)
    console.log(history.state.data);
    this.customersData = history.state.data;

    //initialize search array for nodes in each hub
    if(this.customersData && this.customersData['hubs']){
      for(let i=0;i<this.customersData['hubs'].length;i++){
        var obj={
          'searchString': ""
        }
        this.searchData[this.customersData['hubs'][i]['hubId']]=obj;
      }
    }

    this.route.params.subscribe(params => {
      console.log("customer ID: " + params.id)
      this.custId = params.id
      this.fetchCustomerData(params.id, this.onlyOwned,this.showDeletedSNodes);
      this.fetchLinkedDevices()
      // return;
    });

    this.searchSubscription = this.searchSubject
      .pipe(
        debounceTime(300), // wait 300ms after last keystroke
        distinctUntilChanged() // only emit if value changed
      )
      .subscribe(value => {
        this.onSearchEidChange(value); // your original heavy method
      });

    this.searchSubscriptionSmall = this.searchSubjectSmall
      .pipe(
        debounceTime(800), // wait 300ms after last keystroke
        distinctUntilChanged() // only emit if value changed
      )
      .subscribe(obj=> {
        this.onNodeLevelSearch(obj); // your original heavy method
      });

    this.menuServiceSub = this.nbMenuService.onItemClick().subscribe((event) => {
      console.log("+++++++ " + JSON.stringify(event))
      // if(event.item.title == "Verify Email"){
      //   const pin=prompt("Please enter the passcode");
      //   if (pin) {

      //     //first, verify pin entered by user
      //     this.http.post(this.env.apiUrl + "/api/users/verifyUserPin", { pin: pin })
      //     .subscribe(response => {
      //             this.http.post(this.env.apiUrl + "/api/users/verifyEmail",{emailId:this.customersData['emailId']})
      //                 .subscribe(response=>{
      //                   console.log(response);
      //                   window.location.reload();
      //                 },err=>{
      //                   console.log(err);
      //                 })
      //     }, err => {
      //       this.showToast(3000, "Pin verification failed", 'Error in pin verification');
      //     });
      
      //   } else {
      //     this.showToast(3000, "Please enter pin", 'Pin cannot be empty ! Please try again');
      //   }
      // }
      if(event.item.title == "Resync Voice Assistants"){
        this.dialogService.open(PasswordDialogComponent)
      .onClose.subscribe((password: string | null) => {
        if (password !== null) {
          this.http.post(this.env.apiUrl + "/api/users/verifyUserPin", { pin: password })
          .subscribe(response => {
            console.log(response);
              
              this.http.post(this.env.apiUrl + "/api/sendCommand/resyncVA",{customerId:this.customersData['_id']})
              .subscribe(response=>{
                console.log(response)
                this.showToast(3000,"Resync Voice Assistants","Successfully resynced Voice Assistants")
              },err=>{
                console.log(err);
                this.showToast(3000,"Resync Voice Assistants","Failed to resync Voice Assistants")
              })  
          }, err => {
            console.log(err)
            // this.verifyUser()
            
          })
        } else {
          
        }
      });

      }else if(event.item.title == "Request Access"){
        const pin=prompt("Please enter support access pin");
        if (pin) {

          //first, verify pin entered by user
          this.http.post(this.env.apiUrl + "/api/users/verifySupportAccessPin", { pin: pin })
          .subscribe(response => {
            console.log(response);
            const ticketId = prompt("Please enter Zoho Ticket Number");
            if(ticketId && ticketId != ""){
              this.http.post(this.env.apiUrl + "/api/sendCommand/requestAccess",{customerId:this.customersData['_id'],placeId:event.tag[1],ticketId})
            .subscribe(response=>{
              console.log(response)
              this.showToast(3000,"Request Access","Successfully requested access")
            },err=>{
              console.log(err);
              this.showToast(3000,"Request Access","Failed to request access")
            })     
            }else {
              this.showToast(3000,"Request Access","Zoho Ticket ID is mandatory")
            }    
          }, err => {
            this.showToast(3000, "Pin verification failed", 'Error in pin verification');
          });
      
        } else {
          this.showToast(3000, "Please enter pin", 'Pin cannot be empty ! Please try again');
        }
      }else if(event.item.title == "Trigger Support Access Last State"){
        const pin=prompt("Please enter support access pin");
        if (pin) {

          //first, verify pin entered by user
          this.http.post(this.env.apiUrl + "/api/users/verifySupportAccessPin", { pin: pin })
          .subscribe(response => {
            console.log(response);
            this.http.get(this.env.apiUrl + "/api/hubTransfer/trigger-push?placeId="+event.tag[1])
            .subscribe(response=>{
              console.log(response)
              this.showToast(3000,"Request Access","Successfully triggered push for access")
            },err=>{
              console.log(err);
              this.showToast(3000,"Request Access","Failed to trigger push for access")
            })  
          }, err => {
            this.showToast(3000, "Pin verification failed", 'Error in pin verification');
          });
      
        } else {
          this.showToast(3000, "Please enter pin", 'Pin cannot be empty ! Please try again');
        }
      }
      else if(event.item.title == "Ask Store Rating") {
        this.askStoreRating();
      }
      else if(event.item.title == "Transfer Hubs"){
        var url = ""
        let params = this.customersData['emailId'] ? this.customersData['emailId'] : this.customersData['mobile']
        url = this.router.serializeUrl(this.router.createUrlTree(['hubTransferV2', this.getOwnerHubs() + "|" + params]))
        window.open(url, '_blank')
      }
      else if (event.item.title === 'Transfer') {
        var url = ""
        let params = this.customersData['emailId'] ? this.customersData['emailId'] : this.customersData['mobile']
        url = this.router.serializeUrl(this.router.createUrlTree(['hubTransfer', event.tag[0] + "|" + params]))
        window.open(url, '_blank')
      } else if (event.item.title === 'Replacement') {
        var url = ""
        url = this.router.serializeUrl(this.router.createUrlTree(['hubReplacement', this.custId]))
        console.log("URL : " + url)
        window.open(url, '_blank')
      } else if (event.item.title === 'Update-Status') {
        let hubId = event.tag[0];
        this.openHubConfigDialog(hubId)
      } else if (event.item.title === 'Restart hub') {
        const command=consoleCommands['restart']['value'];
        this.http.post(this.env.apiUrl + "/api/sendCommand",{ command: command, hubId: event.tag[0] })
        .subscribe(response=>{
          console.log(response)
        },err=>{
          console.log(err);
        })
      }else if (event.item.title === 'Clean Sync Rules & Scenes') {
        // const command=consoleCommands['cleanSync_pro']['value'];
        // this.http.post(this.env.apiUrl + "/api/sendCommand",{ command: command, hubId: event.tag[0] })
        // .subscribe(response=>{
        //   console.log(response)
        //   setTimeout(()=>{
        //     this.http.post(this.env.apiUrl + "/api/sendCommand/syncWithEdge",{hubId:event.tag[0]})
        //     .subscribe(response=>{
        //       console.log(response)
        //     },err=>{
        //       console.log(err);
        //     })
        //   },3000);
        // },err=>{
        //   console.log(err);
        // })
            this.http.post(this.env.apiUrl + "/api/sendCommand/syncWithEdge",{hubId:event.tag[0]})
            .subscribe(response=>{
              console.log(response)
            },err=>{
              console.log(err);
            })
      }else if (event.item.title === 'Sync Rules') {
        // const command=consoleCommands['cleanSync_pro']['value'];
        // this.http.post(this.env.apiUrl + "/api/sendCommand",{ command: command, hubId: event.tag[0] })
        // .subscribe(response=>{
        //   console.log(response)
        //   setTimeout(()=>{
        //     this.http.post(this.env.apiUrl + "/api/sendCommand/syncWithEdge",{hubId:event.tag[0]})
        //     .subscribe(response=>{
        //       console.log(response)
        //     },err=>{
        //       console.log(err);
        //     })
        //   },3000);
        // },err=>{
        //   console.log(err);
        // })
            this.http.post(this.env.apiUrl + "/api/sendCommand/triggerProSyncRule",{hubId:event.tag[0],type:2})
            .subscribe(response=>{
              console.log(response)
            },err=>{
              console.log(err);
            })
      }else if (event.item.title === 'Sync Scenes') {
        // const command=consoleCommands['cleanSync_pro']['value'];
        // this.http.post(this.env.apiUrl + "/api/sendCommand",{ command: command, hubId: event.tag[0] })
        // .subscribe(response=>{
        //   console.log(response)
        //   setTimeout(()=>{
        //     this.http.post(this.env.apiUrl + "/api/sendCommand/syncWithEdge",{hubId:event.tag[0]})
        //     .subscribe(response=>{
        //       console.log(response)
        //     },err=>{
        //       console.log(err);
        //     })
        //   },3000);
        // },err=>{
        //   console.log(err);
        // })
            this.http.post(this.env.apiUrl + "/api/sendCommand/triggerProSyncScene",{hubId:event.tag[0],type:1})
            .subscribe(response=>{
              console.log(response)
            },err=>{
              console.log(err);
            })
      }
      else if (event.item.title === 'Remove all Repeaters') {
        const command=consoleCommands['deleteAllRepeater']['value'];
        this.http.post(this.env.apiUrl + "/api/sendCommand",{ command: command, hubId: event.tag[0] })
        .subscribe(response=>{
          console.log(response)
        },err=>{
          console.log(err);
        })
      }
      // else if(event.item.title === "Mark as Testing Required HUB") {
      //   const comment=prompt("Please enter some comment");
      //     if (comment && comment != "") {
      //       var eId = event.tag[0];
      //       this.http.post(this.env.apiUrl+"/api/hubTransfer/serviceTesting",{eid:eId.toLowerCase().replace(/:/g,"").replace(/-/g,""),comment})
      //             .subscribe(response=>{
      //               this.showToast(3000,"Service Testing",'Successfully marked as Testing required')
      //             },err=>{
      //               this.showToast(3000, "Service Testing", 'Failed to mark as Testing required. Please try again');
      //             })
        
      //     } else {
      //       this.showToast(3000, "Service Testing", 'Comment can not be empty');
      //     }
      // }
      else if (event.item.title === 'Trigger OTA'){
        const command=consoleCommands['triggerOTA']['value'];
        this.http.post(this.env.apiUrl + "/api/sendCommand",{ command: command, hubId: event.tag[0] })
        .subscribe(response=>{
          console.log(response)
        },err=>{
          console.log(err);
        })
      }
      else if (event.item.title === 'Redownload Network Params'){
        this.http.post(this.env.apiUrl + "/api/sendCommand/redownloadNetworkParams",{hubId:event.tag[0]})
        .subscribe(response=>{
          console.log(response)
        },err=>{
          console.log(err);
        })
      }
      else if (event.item.title === 'Change Region'){
        this.dialogService.open(PasswordDialogComponent)
    .onClose.subscribe((password: string | null) => {
      if (password !== null) {
        this.http.post(this.env.apiUrl + "/api/users/verifyUserPin", { pin: password })
        .subscribe(response => {
          this.http.post(this.env.apiUrl + "/api/sendCommand/changeRegion",{hubId:event.tag[0]})
                      .subscribe(response=>{
                        console.log(response);
                        window.location.reload();
                      },err=>{
                        console.log(err);
                      })
        }, err => {
          console.log(err)
          
        })
      } else {
        
      }
    });
      }
      else if (event.item.title === 'Request Health Update'){
        const command=consoleCommands['requestHealthUpdate']['value'];
        this.http.post(this.env.apiUrl + "/api/sendCommand",{ command: command, hubId: event.tag[0] })
        .subscribe(response=>{
          console.log(response)
        },err=>{
          console.log(err);
        })
      }
      else if (event.item.title === 'Auto Configure Repeaters'){
        this.http.post(this.env.apiUrl + "/api/sendCommand/autoConfigRepeaters/",{hubId: event.tag[0]})
        .subscribe(response => {
          console.log(response);
        }, err => {
          console.log(err);
        })
      }
      else if (event.item.title === 'Realign Network'){
        const command=consoleCommands['realignNetwork']['value'];
        this.http.post(this.env.apiUrl + "/api/sendCommand",{command: command, hubId: event.tag[0]})
        .subscribe(response => {
          console.log(response);
        }, err => {
          console.log(err);
        })
      }
      else if(event.item.title === 'Toggle Repeater'){
        var nodeId=event.tag[0];
        var hubId=event.tag[1];
        var ownerContactInfo=event.tag[2];
        var ownerAccountId=event.tag[3].toString();
        var nodeInfo=event.tag[1]+":"+event.tag[0];
        var eId = event.tag[4];
        var node = event.tag[5];
        //convert node shortAddress from decimal to hexadecimal and prefix with 0 if single digit
        nodeId=parseInt(nodeId).toString(16);
        if(nodeId.length<2){
          nodeId="0"+nodeId;
        }
      
        this.dialogService.open(PasswordDialogComponent,{
          context:{
            inputType:"text",
            placeholder:"Please enter the slot ID (1-7)"
          }
        })
        .onClose.subscribe((slotId: string | null) => {
          if (slotId !== null) {
            if (slotId) {
              let slodIdInt = parseInt(slotId)
              if(isNaN(slodIdInt) || slodIdInt < 1 || slodIdInt > 7){
                this.showToast(3000,"Invalid Slot ID","Slot ID has to between 1 and 7")
                return;
              }
    
              let nodeType = node["nodeType"];
              if(!this.canBeRepeater.includes(nodeType)) {
                this.showToast(3000,"Toggle Repeater","This device does not support repeater functionality")
                return;
              }
    
    
              let enalbe = "01"
              if(node["isRepeaterNode"]){
                enalbe = "00"
              }
              const command=consoleCommands['toggleRepeater']['value']+' '+nodeId+" "+enalbe+" 01 "+`0${slotId}`;
              this.http.post(this.env.apiUrl + "/api/sendCommand",{ command: command, hubId: hubId })
                .subscribe(response=>{
                  console.log(response["data"]);
                },err=>{
                
                });
            }
          } 
        });
        
      }else if(event.item.title === 'Force Remove'){
        var nodeId=event.tag[0];
        var hubId=event.tag[1];
        var ownerContactInfo=event.tag[2];
        var ownerAccountId=event.tag[3].toString();
        var nodeInfo=event.tag[1]+":"+event.tag[0];
        var eId = event.tag[4];
        //convert node shortAddress from decimal to hexadecimal and prefix with 0 if single digit
        nodeId=parseInt(nodeId).toString(16);
        if(nodeId.length<2){
          nodeId="0"+nodeId;
        }
        
        if(!this.offlineNodes.includes(eId)){
          this.showToast(3000,"Invalid Request","You can not remove online device")
          return
        }

        let hub = event.tag[6];
        if(!hub["isOnline"]) {
          this.showToast(3000,"Invalid Request","HUB is Offline")
          return
        }

        //append node hex id to force remove command
        const command=consoleCommands['forceRemoveNode']['value']+' '+nodeId;

        this.dialogService.open(PasswordDialogComponent)
        .onClose.subscribe((password: string | null) => {
          if (password !== null) {
            this.http.post(this.env.apiUrl + "/api/users/verifyUserPin", { pin: password })
            .subscribe(response => {
              console.log(response)

              this.dialogService.open(PasswordDialogComponent,{
                context:{
                  inputType:'text',
                  placeholder:"Enter Reason of Force Node Removal"
                }
              })
              .onClose.subscribe((reason: string | null) => {
                if (reason !== null) {
                  if(reason && reason != ''){

                    this.dialogService.open(ConfirmDialogComponent, {
                      context: {
                        title: 'BlackList Device',
                        message: 'Do you want to black list this device?',
                        confirmLabel: 'YES',
                        cancelLabel: 'NO',
                      },
                    }).onClose.subscribe(blackList => {
                      this.http.post(this.env.apiUrl + "/api/sendCommand",{ command: command, hubId: hubId,feature:"forceRemoveNode" })
                      .subscribe(response=>{
                        this.http.post(this.env.apiUrl+"/api/engagementData/forceNodeRemoval",{blackList,ownerContactInfo: ownerContactInfo, ownerAccountId: ownerAccountId, nodeInfo: nodeInfo, status: "success",reason,hubId,eId,nodeId,nodeShortId:nodeId})
                        .subscribe(response=>{
                          this.showToast(3000, "Force Node Removal", 'Node is removed Successfully.');
                        },err=>{
                          this.showToast(3000, "Failed database insertion", 'Error in adding log to the database');
                        })
      
                      },err=>{
      
                        this.showToast(3000, "Node removal failed", 'Error in force node removal');
                        this.http.post(this.env.apiUrl+"/api/engagementData/forceNodeRemoval",{blackList,ownerContactInfo: ownerContactInfo, ownerAccountId: ownerAccountId, nodeInfo: nodeInfo, status: "failure"})
                        .subscribe(response=>{
                          console.log('Failure log inserted');
                        },err=>{
                          this.showToast(3000, "Failed database insertion", 'Error in adding log to the database');
                        })
                      
                      });
                    });
                  }else {
                    this.showToast(3000,"Force Node Removal","Reason is needed for force node removal. Enter Zoho Ticket ID if available.")
                  }
                } else {
                  
                }
              });
            }, err => {
              console.log(err)
              
            })
          } else {
            
          }
        });
      }else if(event.item.title === 'Delay Modifier'){

        this.dialogService.open(PasswordDialogComponent,{
          context:{
            inputType:"text",
            placeholder:"Enter Time (in Decimal)"
          }
        })
        .onClose.subscribe((time: string | null) => {
            if (time !== null) {
              var nodeId=event.tag[0];
            var hubId=event.tag[1];
            var ownerContactInfo=event.tag[2];
            var ownerAccountId=event.tag[3].toString();
            var nodeInfo=event.tag[1]+":"+event.tag[0];
            var eId = event.tag[4];
            //convert node shortAddress from decimal to hexadecimal and prefix with 0 if single digit
            nodeId=parseInt(nodeId).toString(16);
            if(nodeId.length<2){
              nodeId="0"+nodeId;
            }

            time=parseInt(time).toString(16);
            if(time.length<2){
              time="0"+time;
            }
            
            if(this.offlineNodes.includes(eId)){
              this.showToast(3000,"Invalid Request","You can not do this operation for offline device")
              return
            }

            /*

              Latest Generation
              2S_3 , 3S_3 , 2D_2,  3D_3

              03 00 0E 00 00 00 00 0c 00 00 32 02(Node addr) 00 00 80 18 07 01 01 04 

              Old Generation
              2S_1, 2S_2, 3S_1, 3S_2, 2D_1, 3D_1, 3D_2, 2S1D_1

              03 00 0E 00 00 00 00 0c 00 00 32 03(Node addr) 00 00 80 10 06 01 01 04

            */

            let newGenDevices = ["SS_3","IWS_2S","SSS_3","IWS_3S","IWS_2D_2","IWS_2D","IWS_3D_3","IWS_3D"]
            let oldGenDevices = ["SS_1","SS_2","SSS_1","SSS_2","IWS_2D_1","IWS_3D_1","IWS_3D_2","SSD_1"]
            let group3Old = ["IWS_GC_1","IWS_GC_2","IWS_MC_1","IWS_MC_2","IWS_16A_1","IWS_2RC_1"]
            let group4New = ["IWS_GC_3","GC","IWS_MC_3","CC","IWS_16A_2","IWS_16A","IWS_2RC_2","IWS_2RC"]
            let node = event.tag[5];
            let nodeType = node["nodeType"];
            var varPart = '';
            if(nodeType == "IWS_2S") {
              if(node["firmwareVersion"] == "00000109050d04070001"){
                varPart = "00 00 80 18 07 01 01"
              }else {
                varPart = "00 00 80 18 02 01 01"
              }
            }else if(newGenDevices.includes(nodeType)){
              varPart = "00 00 80 18 07 01 01"
            }else if(oldGenDevices.includes(nodeType)){
              varPart = "00 00 80 10 06 01 01"
            }else if(group4New.includes(nodeType)){
              varPart = "00 00 80 18 06 01 01"
            }else if(group3Old.includes(nodeType)){
              varPart = "00 00 80 10 06 01 01"
            }

            if(varPart == ""){
              this.showToast(3000,"Delay Modification","Operation is not applicable for this device")
              return;
            }
            
            console.log("vaPart",varPart);
            console.log("vaPart",eId);
            
            // return;
            

            //append node hex id to force remove command
            const command=consoleCommands['delayModifier']['value']+' '+nodeId + ' '+varPart+' '+time;
            console.log("command",command);

            this.dialogService.open(PasswordDialogComponent)
            .onClose.subscribe((password: string | null) => {
              if (password !== null) {
                this.http.post(this.env.apiUrl + "/api/users/verifyUserPin", { pin: password })
                .subscribe(response => {
                  console.log(response)
                  
                  this.dialogService.open(PasswordDialogComponent,{
                    context:{
                      inputType:"text",
                      placeholder:"Enter Reason of Delay Modification"
                    }
                  })
                  .onClose.subscribe((reason: string | null) => {
                    if(reason && reason != '' && reason != null){
                      //if response, then make a command call with hubId
                      this.http.post(this.env.apiUrl + "/api/sendCommand",{ command: command, hubId: hubId,feature:"delayModifier" })
                      .subscribe(response=>{
                        this.http.post(this.env.apiUrl+"/api/engagementData/delayModifier",{nodeId:eId,reason,time})
                        .subscribe(response=>{
                          this.showToast(3000,"Delay Mofication",'Successfully modified delay')
                        },err=>{
                          this.showToast(3000, "Failed Delay Modication Log Insertion", 'Error in adding delay modication time to the database');
                        })
                      },err=>{
                        this.showToast(3000, "Delay Modication Failed", 'Error in modify delay');                
                      });
                    }else {
                      this.showToast(3000,"Delay Modification","Reason is needed for delay mofication. Enter Zoho Ticket ID if available.")
                    }
                  });
                
                }, err => {
                  console.log(err)
                  
                })
              } else {
                
              }
            });
          } else {
            
          }
        });
      }else if(event.item.title === 'Trigger Node OTA'){
          var nodeId=event.tag[0];
          var hubId=event.tag[1];
          var ownerContactInfo=event.tag[2];
          var ownerAccountId=event.tag[3].toString();
          var nodeInfo=event.tag[1]+":"+event.tag[0];
          var eId = event.tag[4];
          //convert node shortAddress from decimal to hexadecimal and prefix with 0 if single digit
          nodeId=parseInt(nodeId).toString(16);
          if(nodeId.length<2){
            nodeId="0"+nodeId;
          }
          
          if(this.offlineNodes.includes(eId)){
            this.showToast(3000,"Invalid Request","You can not do this operation for offline device")
            return
          }

          let node = event.tag[5];
          let nodeType = node["nodeTypeRaw"].toString(16);
          if(nodeType.length < 2) {
            nodeType = "0"+nodeType;
          }
          var varPart = '00 00 4f 05';
          
          if(varPart == ""){
            this.showToast(3000,"Trigger Node OTA","Operation is not applicable for this device")
            return;
          }
          
          console.log("vaPart",varPart);
          console.log("vaPart",eId);
          
          // return;
          

          //append node hex id to force remove command
          const command=varPart+' '+nodeId + ' '+nodeType;
          console.log("command",command);

          this.dialogService.open(PasswordDialogComponent)
        .onClose.subscribe((password: string | null) => {
          if (password !== null) {
            this.http.post(this.env.apiUrl + "/api/users/verifyUserPin", { pin: password })
            .subscribe(response => {
              console.log(response)
              //if response, then make a command call with hubId
              this.http.post(this.env.apiUrl + "/api/sendCommand",{ command: command, hubId: hubId,feature:"triggerNodeOTA" })
              .subscribe(response=>{
                this.showToast(3000,"Trigger Node OTA",'Successfully triggered OTA')
              },err=>{
                this.showToast(3000, "Trigger Node OTA", 'Error in triggering OTA');                
              });
            
            }, err => {
              console.log(err)
              
            })
          } else {
            
          }
        });
      }else if(event.item.title === 'ReSync DALI Parameters'){
          var nodeId=event.tag[0];
          var hubId=event.tag[1];
          var ownerContactInfo=event.tag[2];
          var ownerAccountId=event.tag[3].toString();
          var nodeInfo=event.tag[1]+":"+event.tag[0];
          var eId = event.tag[4];
          //convert node shortAddress from decimal to hexadecimal and prefix with 0 if single digit
          nodeId=parseInt(nodeId).toString(16);
          if(nodeId.length<2){
            nodeId="0"+nodeId;
          }
          
          if(this.offlineNodes.includes(eId)){
            this.showToast(3000,"Invalid Request","You can not do this operation for offline device")
            return
          }

          let node = event.tag[5];
          let nodeType = node["nodeTypeRaw"].toString(16);
          if(nodeType.length < 2) {
            nodeType = "0"+nodeType;
          }
          
          console.log("Resync DALI Parameters",node);
          let nodeTypeActual = node["nodeType"];
          if(nodeTypeActual != "DALI_SL") {
            this.showToast(3000,"ReSync DALI Parameters","Operation is not permitted for this device")
            return;
          }
          

          this.dialogService.open(PasswordDialogComponent)
        .onClose.subscribe((password: string | null) => {
          if (password !== null) {
            this.http.post(this.env.apiUrl + "/api/users/verifyUserPin", { pin: password })
            .subscribe(response => {
              console.log(response)
              
              this.http.post(this.env.apiUrl + "/api/hubTransfer/resyncDali",{ hubId: hubId,feature:"resyncDali",nodeEid:eId,nodeId:node["shortAddress"] })
              .subscribe(response=>{
                this.showToast(3000,"Resync DALI Parameters",'Successfully ReSynced DALI Parameters')
              },err=>{
                this.showToast(3000, "Resync DALI Parameters", 'Error in ReSyncing DALI Parameters');                
              });
            
            }, err => {
              console.log(err)
              
            })
          } else {
            
          }
        });
      }
      else if(event.item.title === "Delete Lock Users") {
          this.dialogService.open(PasswordDialogComponent)
          .onClose.subscribe((password: string | null) => {
            if (password !== null) {
              this.http.post(this.env.apiUrl + "/api/users/verifyUserPin", { pin: password })
              .subscribe(response => {
                console.log(response)

                this.dialogService.open(PasswordDialogComponent,{
                  context:{
                    inputType:"text",
                    placeholder:"Enter Zoho Ticket ID"
                  }
                })
                .onClose.subscribe((ticket: string | null) => {
                  if (ticket !== null && ticket != '') {
                    console.log(response)
                      var eId = event.tag[4];
                      let node = event.tag[5];
                      let nodeType = node["nodeType"];
                      if(!nodeType.includes("YLM_")) {
                        this.showToast(3000,"Lock User Deletion",'Operation is not permitted for this device')
                        return;
                      }
                      this.dialogService.open(ConfirmDialogComponent, {
                        context: {
                          title: 'Delete Lock Users',
                          message: 'Doing this will delete all NON-SYNCED Lock Users. This is will not delete users from the actual Lock, customer has to re-pair the YLM to reset. Are you sure you want to delete lock users? This operation can not be undone.',
                          confirmLabel: 'Delete',
                          cancelLabel: 'Cancel',
                        },
                      }).onClose.subscribe(shouldDelete => {
                        if (shouldDelete) {
                          this.http.post(this.env.apiUrl+"/api/engagementData/deleteLockUser",{nodeId:eId,ticket})
                          .subscribe(response=>{
                            this.showToast(3000,"Lock User Deletion",'Successfully deleted Lock Users')
                          },err=>{
                            this.showToast(3000, "Lock User Deletion", 'Error in deleting Lock Users');
                          }) 
                        } 
                      });
                  } else {
                    
                  }
                });
              }, err => {
                console.log(err)
                
              })
            } else {
              
            }
          });
      }
      // else if(event.item.title === "Mark as Testing Required") {
      //   const comment=prompt("Please enter some comment");
      //   console.log(comment);
      //     if (comment && comment != "") {
      //       var eId = event.tag[4];
      //       console.log(event.tag);
      //       this.http.post(this.env.apiUrl+"/api/hubTransfer/serviceTesting",{eid:eId.toLowerCase().replace(/:/g,"").replace(/-/g,""),comment})
      //             .subscribe(response=>{
      //               this.showToast(3000,"Service Testing",'Successfully marked as Testing required')
      //             },err=>{
      //               this.showToast(3000, "Service Testing", 'Failed to mark as Testing required. Please try again');
      //             })
        
      //     } else {
      //       this.showToast(3000, "Service Testing", 'Comment can not be empty');
      //     }
      // }
    });
  }

  getOwnerHubs():string{
    let hubs = this.customersData['hubs'];
    var ownedHubs = [];
    if(hubs != null){
      for(var i=0;i<hubs.length;i++){
        let hub = hubs[i];
        if(!hub.isSharedHub){
          ownedHubs.push(hub.hubId)
        }
      }
    }
    return ownedHubs.join("|")
  }

  isNonTurnOffableDevice(appType:String):boolean{  
    switch (appType) {
      case "IR_DEVICE":
      case "MOTOR_CONTROLLER":
      case "GATE_CONTROLLER":
      case "DOS_1":
      case "REPEATER":
      case "ENERGY_METER":
      case "VDP":
      case "LOCK_REMOTE":
      case "TOUCH_RELAY_CONTROLLER":
      case "DALI_CONTROLLER":
        return true;
      default:
        return false;
    }
  }

  //function to sort and push shared hubs to the end of the list
  sortSharedHubs(responseData:object){
    if(responseData["hubs"]) {
      responseData['hubs'].sort(function(a:object,b:object){
        if(a['isSharedHub']){
          return 1
        }else if(b['isSharedHub']){
          return -1
        }
      })
    }
  }

  getHumanRepeaterNo(no){
    if(no == 254){
      return " R1"
    }else if(no == 253){
      return " R2"
    }else if(no == 252){
      return " R3"
    }else if(no == 251){
      return " R4"
    }else if(no == 250){
      return " R5"
    }else if(no == 249){
      return " R6"
    }else if(no == 248){
      return " R7"
    }
    return no
  }

  getHumanReadableTime(date){
    return moment(date).format('lll');
  }

  getTouchWarrantyTime(date){
    return moment(date).add("years","3").format("lll");
  }

  containsAndroid(){
    if(this.customersData['platforms']) {
      return this.customersData['platforms'].map(e=>e.type).includes('ANDROID')
    }
    return false;
  }

  containsIOS(){
    if(this.customersData['platforms']) {
      return this.customersData['platforms'].map(e=>e.type).includes('IOS')
    }
    return false;
  }

  getAndroidTooltip(){
    let androids = this.customersData['platforms'].filter(e=>{
      return e.type == "ANDROID"
    })
    let info = androids[0].version.toString() + (androids[0].buildName == undefined ? "" : " - "+androids[0].buildName.toString())
    let keys = Object.keys(androids[0].otherInfo);
    let msg = "";
    for(const key of keys) {
      msg += key + " : "+androids[0].otherInfo[key] + " , ";
    }
    return info + " , " + msg;
  }

  getIOSTooltip(){
    let ios = this.customersData['platforms'].filter(e=>{
      return e.type == "IOS"
    })
    let info = ios[0].version.toString() + (ios[0].buildName == undefined ? "" : " - "+ios[0].buildName.toString())
    let keys = Object.keys(ios[0].otherInfo);
    let msg = "";
    for(const key of keys) {
      msg += key + " : "+ios[0].otherInfo[key] + " , ";
    }
    return info + " , " + msg;
  }

  askStoreRating(){
        this.dialogService.open(PasswordDialogComponent)
        .onClose.subscribe((password: string | null) => {
          if (password !== null) {
            this.http.post(this.env.apiUrl + "/api/users/verifyUserPin", { pin: password })
            .subscribe(response => {
              console.log(response)
              this.http.post(this.env.apiUrl+"/api/hubTransfer/ask-store-rating",{customerId:this.customersData["_id"].toString()}).subscribe(response=>{
                if(response["success"]){
                  this.showToast(4000,"Ask Store Rating",response["message"]);
                }
              },err=>{
                console.log(err);
                this.showToast(4000,"Ask Store Rating",err["message"]);
              })
            }, err => {
              console.log(err)
              
            })
          } else {
            
          }
        });
  }

  getAssociationCount(associations){
    let total = 0;
    for(const association of associations){
      total += association.nodeAppIds.length;
    }
    return total;
  }

  autoRefreshLogsTimerMap = {};
  autoRefreshStatusTimerMap = {};

  clearAutoRefreshLogsForAll(){
    let keys = Object.keys(this.autoRefreshLogsTimerMap);
    for(const key of keys){
      this.clearAutoRefreshLogsFor(key);
    }
  }

  clearAutoRefreshStatusForAll(){
    let keys = Object.keys(this.autoRefreshStatusTimerMap);
    for(const key of keys){
      this.clearAutoRefreshStatusFor(key);
    }
  }

  clearAutoRefreshLogsFor(hubId){
    let refreshIntervalId = this.autoRefreshLogsTimerMap[hubId]
    if(refreshIntervalId) {
      clearInterval(refreshIntervalId);
    }
    this.autoRefreshLogsTimerMap[hubId] = undefined;
  }

  clearAutoRefreshStatusFor(hubId){
    let refreshIntervalId = this.autoRefreshStatusTimerMap[hubId]
    if(refreshIntervalId) {
      clearInterval(refreshIntervalId);
    }
    this.autoRefreshStatusTimerMap[hubId] = undefined;
  }

  addAutoRefreshLogsFor(hubId,hub,index){
    let newIntervalId = setInterval(()=>{
      this.fetchCriticalLogs(hub.hubId, 10, 0, index, hub.placeId,this.today,true)
    },parseInt(hub.autoRefreshLogsTime) * 1000);
    this.autoRefreshLogsTimerMap[hubId] = newIntervalId;
  }

  addAutoRefreshStatusFor(hubId,hub,index){
    let newIntervalId = setInterval(()=>{
      this.fetchStatus(hubId,hub);
    },parseInt(hub.autoRefreshLogsTime) * 1000);
    this.autoRefreshStatusTimerMap[hubId] = newIntervalId;
  }

  autoRefreshLogsTimeChanged(hub,index){
    let hubId = hub.hubId;
    this.clearAutoRefreshLogsFor(hubId)
    this.addAutoRefreshLogsFor(hubId,hub,index)
  }

  autoRefreshStatusTimeChanged(hub,index){
    let hubId = hub.hubId;
    this.clearAutoRefreshStatusFor(hubId)
    this.addAutoRefreshStatusFor(hubId,hub,index)
  }

  autoRefreshLogsToggleChanged(hub,index){
    let hubId = hub.hubId;
    if(hub.autoRefreshLogs) {
      hub.autoRefreshLogs = false;
      hub.autoRefreshLogsTime = "15"
      this.clearAutoRefreshLogsFor(hubId);
    }else {
      this.addAutoRefreshLogsFor(hubId,hub,index);
    }
  }

  autoRefreshStatusToggleChanged(hub,index){
    let hubId = hub.hubId;
    if(hub.autoRefreshStatus) {
      hub.autoRefreshStatus = false;
      hub.autoRefreshStatusTime = "5"
      this.clearAutoRefreshStatusFor(hubId);
    }else {
      this.addAutoRefreshStatusFor(hubId,hub,index);
    }
  }

  fetchStatusMap = {}
  fetchLogsMap = {}

  fetchStatus(hubId,hub){
    if(this.fetchStatusMap[hubId]) {
      return;
    }
    this.fetchStatusMap[hubId] = true
    this.http.get(this.env.apiUrl + "/api/users/getStatus/"+hubId)
      .subscribe(response => {
        delete this.fetchStatusMap[hubId]
        let pNodes = response["pNodes"];
        if(pNodes){
          pNodes.forEach(pNodeStatus=>{
            if(pNodeStatus.nodeId == 0){
              hub.isOffline = pNodeStatus.isOffline
            }else {
              if(hub.nodes){
                hub.nodes.forEach(node => {
                  if(node.shortAddress == pNodeStatus.nodeId) {
                    if(node.apps){
                      node.apps.forEach(app => {
                        if(app.address == pNodeStatus.appId) {
                          app.isOffline = pNodeStatus.isOffline
                          app.currentStatus = pNodeStatus.currentStatus
                          app.currentControl = pNodeStatus.currentControl
                        }   
                      });
                    }
                  }
                });
              }
            }
          })
        }
        let sNodes = response["sNodes"];
        if(sNodes) {
          sNodes.forEach(sNodeStatus=>{
            if(hub.nodes){
              hub.nodes.forEach(node => {
                if(node.sNodes) {
                  node.sNodes.forEach(sNode => {
                    if(sNode.sNodeId == sNodeStatus.sNodeId){
                      sNode.sNodeState = sNodeStatus.sNodeState
                      if(sNode.sAppsV2) {
                        sNode.sAppsV2.forEach(sApp => {
                          sNodeStatus.sAppsStatus.forEach(sAppStatus => {
                            if(sAppStatus.sAppId == sApp.sAppId){
                              sApp["isOffline"] = sAppStatus.state == "OFFLINE";
                              if(sAppStatus.settings && sAppStatus.settings.action != undefined){
                                sApp["action"] = sAppStatus.settings.action == 0 ? "OFF" : "ON";
                              }
                            }
                          });
                        });
                      }
                    }
                  });
                }
              });
            }
            if(hub.sNodes) {
              hub.sNodes.forEach(sNode => {
                    if(sNode.sNodeId == sNodeStatus.sNodeId){
                      sNode.sNodeState = sNodeStatus.sNodeState
                      if(sNode.sApps) {
                        sNode.sApps.forEach(sApp => {
                          sNodeStatus.sAppsStatus.forEach(sAppStatus => {
                            if(sAppStatus.sAppId == sApp.sAppId){
                              sApp["isOffline"] = sAppStatus.state == "OFFLINE";
                              if(sAppStatus.settings && sAppStatus.settings.action != undefined){
                                sApp["action"] = sAppStatus.settings.action == 0 ? "OFF" : "ON";
                              }
                            }
                          });
                        });
                      }
                    }
                  });
            }
          })
        }

        let metaData = response["metaData"]
        if(metaData){
          metaData.forEach(data=>{
            if(data.nodeId == 0){
              hub.rssi = data.rssi;
              hub.temperature = data.temperature
            }else {
              if(hub.nodes) {
                hub.nodes.forEach(node => {
                  if(node.shortAddress == data.nodeId) {
                    node.rssi = data.rssi;
                    node.temperature = data.temperature;
                    node.voltage = data.voltage
                  }
                });
              }
            }
          })
        }
  },err => {
        delete this.fetchStatusMap[hubId]
      })
  }

  fetchCustomerData(data, onlyOwned: boolean,showDeletedSNodes:boolean) {
    this.isLoading = true;
    this.clearAutoRefreshLogsForAll();
    this.clearAutoRefreshStatusForAll();
    this.http.get(this.env.apiUrl + "/api/users/getInfo/" + data + "?onlyOwned=" + onlyOwned+"&showDeletedSNodes="+showDeletedSNodes)
      .subscribe(response => {
        console.log(response['docs']);
        this.isLoading = false;
        if(response){
          this.sortSharedHubs(response['docs']);
        }
        this.customersData = response['docs'];
        if(this.customersData["hubs"]) {
          this.allHubData = cloneDeep(this.customersData["hubs"]);
          for(let i=0;i<this.allHubData.length;i++){
            this.allHubData[i].autoRefreshLogs = false
            this.allHubData[i].autoRefreshLogsTime = "15"
            this.autoRefreshLogsTimerMap[this.allHubData[i].hubId] = undefined;

            this.allHubData[i].autoRefreshStatus = false
            this.allHubData[i].autoRefreshStatusTime = "5"
            this.autoRefreshStatusTimerMap[this.allHubData[i].hubId] = undefined;
          }
          console.log("this.allHubData",this.allHubData); 
        }
        this.custInfoDataListener.next(true);

        //initialize search array for nodes in each hub
        if(this.customersData['hubs']){
          for(let i=0;i<this.customersData['hubs'].length;i++){
            var obj={
              'searchString': ""
            }
            this.customersData['hubs'][i]["nodeCount"] = this.customersData['hubs'][i].nodes == undefined ? 0 : this.customersData['hubs'][i].nodes.length;
            this.searchData[this.customersData['hubs'][i]['hubId']]=obj;
            this.customersData["hubs"][i].graphStart = new Date(this.customersData["hubs"][i].graphStart);
            this.customersData["hubs"][i].graphEnd = new Date(this.customersData["hubs"][i].graphEnd);

            this.customersData["hubs"][i].autoRefreshLogs = false
            this.customersData["hubs"][i].autoRefreshLogsTime = "15"
            this.autoRefreshLogsTimerMap[this.customersData["hubs"][i].hubId] = undefined;

            this.customersData["hubs"][i].autoRefreshStatus = false
            this.customersData["hubs"][i].autoRefreshStatusTime = "5"
            this.autoRefreshStatusTimerMap[this.customersData["hubs"][i].hubId] = undefined;
          }
        }

        for(let i=0;i<this.customersData['hubs'].length;i++){
          if(this.customersData["hubs"][i]["nodes"]) {
            for(let j=0;j<this.customersData['hubs'][i]['nodes'].length;j++){
              this.customersData["hubs"][i]["nodes"][j].graphStart = new Date(this.customersData["hubs"][i]["nodes"][j].graphStart);
              this.customersData["hubs"][i]["nodes"][j].graphEnd = new Date(this.customersData["hubs"][i]["nodes"][j].graphEnd);

              let node = this.customersData["hubs"][i]["nodes"][j];
              if(node.sNodes) {
                for(const sNode of node.sNodes){
                  if(sNode.sAppsV2) {
                    for(const sApp of sNode.sAppsV2){
                      let sAppsStatus = sNode.sAppsStatus;
                      if(sAppsStatus){
                        for(const status of sAppsStatus) {
                          if(status.sAppId == sApp.sAppId){
                            sApp["isOffline"] = status.state == "OFFLINE";
                            if(status.settings && status.settings.action != undefined){
                              sApp["action"] = status.settings.action == 0 ? "OFF" : "ON";
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }

        //checks app status of all apps in all nodes and depending on that, inserts node id in offline node array.
        for(let i=0;i<this.customersData['hubs'].length;i++){
          for(let j=0;j<this.customersData['hubs'][i]['nodes'].length;j++){
            var flag=0;
            appLoop:
            for(let k=0;k<this.customersData['hubs'][i]['nodes'][j]['apps'].length;k++){
              if(!this.customersData['hubs'][i]['nodes'][j]['apps'][k]['isOffline']){
                flag=1;
                break appLoop;
              }
            }
            if(flag==0){
              this.offlineNodes.push(this.customersData['hubs'][i]['nodes'][j]['nodeId']);
            }
          }

          for(let j=0;j<this.customersData['hubs'][i]['sNodes'].length;j++){
            for(let k=0;k<this.customersData['hubs'][i]['sNodes'][j]['sApps'].length;k++){
              let app = this.customersData['hubs'][i]['sNodes'][j]['sApps'][k];
              let sAppId = app.sAppId;
              let sNode = this.customersData['hubs'][i]['sNodes'][j];
              let sAppsStatus = sNode.sAppsStatus;
              if(sAppsStatus){
                for(const status of sAppsStatus) {
                  if(status.sAppId == sAppId){
                    this.customersData['hubs'][i]['sNodes'][j]['sApps'][k]["isOffline"] = status.state == "OFFLINE";
                    if(status.settings && status.settings.action != undefined){
                      this.customersData['hubs'][i]['sNodes'][j]['sApps'][k]["action"] = status.settings.action == 0 ? "OFF" : "ON";
                    }
                  }
                }
              }
            }
          }
        }




        if(this.customersData['hubs']){
          this.customersData['hubs'].sort((h1,h2)=>{
            if(h1.isOnline) {
              return -1;
            }
            return 0;
          })
        }
        
      }, err => {
        this.isLoading = false;
        console.log(err);
        this.custInfoDataListener.next(false);
      })
  }

  scrollToLinkedDevices(){
    const section = document.getElementById('linkedDevicesSection');
    if (section) {
      this.viewportScroller.scrollToAnchor('linkedDevicesSection');
    }
  }

  formatLockId(lockId) {
  if (!lockId || typeof lockId !== "string") {
    return "N/A"; // handle null, undefined, non-string
  }

  const trimmed = lockId.trim();
  if (trimmed.length === 0) {
    return "N/A"; // empty string after trimming
  }

  if (trimmed.length <= 10) {
    return trimmed; // too short to abbreviate
  }

  const firstPart = trimmed.slice(0, 5);
  const lastPart = trimmed.slice(-5);
  return `${firstPart}...${lastPart}`;
}

  fetchLinkedDevices(){
    this.http.get(this.env.apiUrl + "/api/hubTransfer/linked-devices/" + this.custId )
      .subscribe(response => {
        console.log(response);
        this.linkedDevices.yale = response["linkedDevices"]["yale"] ?? []
      }, err => {
        console.log(err);
      })
  }

  fetchCriticalLogs(hubId, l, p, index, placeId, date,isForAutoRefresh=false) {
    if(isForAutoRefresh){
      if(this.fetchLogsMap[hubId]) {
        return;
      }
      this.fetchLogsMap[hubId] = true
    }
    console.log("date - " + date); 
    if(date == null)
      date = new Date();
    this.http.get(this.env.apiUrl + "/api/criticalLogs/v2?hubId=" + hubId + "&placeId=" + placeId + "&date=" + date)
      .subscribe(response => {
        console.log(response);
        delete this.fetchLogsMap[hubId]
        let docsLen = response['docs'].length
        // this.customersData['hubs'][index]['criticalLogs'] = response['docs'];
        // this.customersData['hubs'][index]['criticalLogsSize'] = parseInt(response['docs'].length);
        // console.log(this.customersData);
        if(docsLen > 0) {
          this.customersData['hubs'][index]['criticalLogs'] = response['docs'];
          this.customersData['hubs'][index]['startDate'] = response['docs'][docsLen-1]['capturedAt'];
          this.customersData['hubs'][index]['endDate'] = response['docs'][0]['capturedAt'];
        } else {
          this.customersData['hubs'][index]['criticalLogs'] = [];
          this.customersData['hubs'][index]['startDate'] = "N/A";
          this.customersData['hubs'][index]['endDate'] = "N/A";
        }
        this.customersData['hubs'][index]['currentPage'] = 1;
      }, err => {
        console.log(err);
        delete this.fetchLogsMap[hubId]
      })
  }

  showAllHealthDataChangeHub(checked,hub){
    hub["showAllHealthData"] = checked
    // this.fetchHealthGraph(hub.hubId,'Hub', hub.showHealthGraph,hub.showAllHealthData)
  }

  showAllHealthDataChangeNode(checked,node){
    node["showAllHealthData"] = checked
    //this.fetchHealthGraph(node.nodeId, node.nodeType,node.showHealthGraph,node.showAllHealthData)
  }

  fetchHealthGraph(nodeId, relType, shouldShow,showAllHealthData,device) {
    device.showHealthGraph = true
    this.http.post(this.env.apiUrl + "/api/health/console/" + nodeId + "/" + relType+"?showAllData="+showAllHealthData,{
      startDate:device.graphStart,
      endDate:device.graphEnd
    })
        .subscribe(response => {
          // console.log(response);
          if(response["finalData"]) {
            this.handlehealthGraphResponse(response, nodeId)
          }else if(response["oldData"]) {
            this.handlehealthGraphResponseOld(response, nodeId)
          }
        }, err => {
          console.log(err);
        })
  }

  fetchRepeaterGraph(hubId, shouldShow) {
    // var jsonData={"cols":[{"id":"Node Id","label":"","type":"string","pattern":""},{"id":"Parent Id","label":"","type":"string","pattern":""},{"id":"ToolTip","label":"","type":"string","pattern":""}],"rows":[{"c":[{"v":"0"},{"v":""},{"v":"HUB"}]},{"c":[{"v":"0"},{"v":"0"},{"v":"Master"}]},{"c":[{"v":"1"},{"v":"0"},{"v":"Rssi: -78, relative to: null\u003cbr\u003eRssi: -76, relative to: null\u003cbr\u003eRssi: -78, relative to: null\u003cbr\u003eRssi: -119, relative to: null\u003cbr\u003e"}]},{"c":[{"v":"2"},{"v":"6"},{"v":"Rssi: -75, relative to: null\u003cbr\u003eRssi: -70, relative to: null\u003cbr\u003eRssi: -119, relative to: null\u003cbr\u003eRssi: -119, relative to: null\u003cbr\u003e"}]},{"c":[{"v":"3"},{"v":"6"},{"v":"Rssi: -69, relative to: null\u003cbr\u003eRssi: -65, relative to: null\u003cbr\u003eRssi: -119, relative to: null\u003cbr\u003eRssi: -119, relative to: null\u003cbr\u003e"}]},{"c":[{"v":"4"},{"v":"0"},{"v":"Rssi: -119, relative to: null\u003cbr\u003eRssi: -119, relative to: null\u003cbr\u003eRssi: -119, relative to: null\u003cbr\u003eRssi: -119, relative to: null\u003cbr\u003e"}]},{"c":[{"v":"5"},{"v":"0"},{"v":"Rssi: -71, relative to: null\u003cbr\u003eRssi: -73, relative to: null\u003cbr\u003eRssi: -119, relative to: null\u003cbr\u003eRssi: -119, relative to: null\u003cbr\u003e"}]},{"c":[{"v":"6"},{"v":"0"},{"v":"Rssi: -59, relative to: null\u003cbr\u003eRssi: -119, relative to: null\u003cbr\u003eRssi: -119, relative to: null\u003cbr\u003eRssi: -119, relative to: null\u003cbr\u003e"}]},{"c":[{"v":"7"},{"v":"0"},{"v":"Rssi: -119, relative to: null\u003cbr\u003eRssi: -119, relative to: null\u003cbr\u003eRssi: -119, relative to: null\u003cbr\u003eRssi: -119, relative to: null\u003cbr\u003e"}]},{"c":[{"v":"8"},{"v":"0"},{"v":"Rssi: -119, relative to: null\u003cbr\u003eRssi: -119, relative to: null\u003cbr\u003eRssi: -119, relative to: null\u003cbr\u003eRssi: -119, relative to: null\u003cbr\u003e"}]},{"c":[{"v":"9"},{"v":"0"},{"v":"Rssi: -65, relative to: null\u003cbr\u003eRssi: -65, relative to: null\u003cbr\u003eRssi: -119, relative to: null\u003cbr\u003eRssi: -119, relative to: null\u003cbr\u003e"}]},{"c":[{"v":"10"},{"v":"0"},{"v":"Rssi: -61, relative to: null\u003cbr\u003eRssi: -79, relative to: null\u003cbr\u003eRssi: -34, relative to: null\u003cbr\u003eRssi: -90, relative to: null\u003cbr\u003e"}]},{"c":[{"v":"11"},{"v":"0"},{"v":"Rssi: -119, relative to: null\u003cbr\u003eRssi: -119, relative to: null\u003cbr\u003eRssi: -119, relative to: null\u003cbr\u003eRssi: -119, relative to: null\u003cbr\u003e"}]},{"c":[{"v":"12"},{"v":"0"},{"v":"Rssi: -119, relative to: null\u003cbr\u003eRssi: -119, relative to: null\u003cbr\u003eRssi: -119, relative to: null\u003cbr\u003eRssi: -119, relative to: null\u003cbr\u003e"}]},{"c":[{"v":"13"},{"v":"0"},{"v":"Rssi: -119, relative to: null\u003cbr\u003eRssi: -119, relative to: null\u003cbr\u003eRssi: -119, relative to: null\u003cbr\u003eRssi: -119, relative to: null\u003cbr\u003e"}]},{"c":[{"v":"14"},{"v":"0"},{"v":"Rssi: -55, relative to: null\u003cbr\u003eRssi: -75, relative to: null\u003cbr\u003eRssi: -119, relative to: null\u003cbr\u003eRssi: -77, relative to: null\u003cbr\u003e"}]},{"c":[{"v":"15"},{"v":"0"},{"v":"Rssi: -119, relative to: null\u003cbr\u003eRssi: -119, relative to: null\u003cbr\u003eRssi: -119, relative to: null\u003cbr\u003eRssi: -119, relative to: null\u003cbr\u003e"}]},{"c":[{"v":"17"},{"v":"6"},{"v":"Rssi: -61, relative to: null\u003cbr\u003eRssi: -60, relative to: null\u003cbr\u003eRssi: -119, relative to: null\u003cbr\u003eRssi: -119, relative to: null\u003cbr\u003e"}]},{"c":[{"v":"16"},{"v":"0"},{"v":"Rssi: -119, relative to: null\u003cbr\u003eRssi: -119, relative to: null\u003cbr\u003eRssi: -119, relative to: null\u003cbr\u003eRssi: -119, relative to: null\u003cbr\u003e"}]},{"c":[{"v":"19"},{"v":"6"},{"v":"Rssi: -77, relative to: null\u003cbr\u003eRssi: -74, relative to: null\u003cbr\u003eRssi: -119, relative to: null\u003cbr\u003eRssi: -119, relative to: null\u003cbr\u003e"}]},{"c":[{"v":"18"},{"v":"6"},{"v":"Rssi: -77, relative to: null\u003cbr\u003eRssi: -77, relative to: null\u003cbr\u003eRssi: -119, relative to: null\u003cbr\u003eRssi: -119, relative to: null\u003cbr\u003e"}]}]};
    // this.repeaterGraph.data = jsonData
    this.repeaterGraph.data[hubId] = null;
    if (!shouldShow)
      this.http.get(this.env.apiUrl + "/api/repeaterGraph/fetchByHubId/" + hubId)
        .subscribe(response => {
          this.handleRepeaterGraphResponse(response, hubId)
        }, err => {
          //console.log(err);
        })
  }

  fetchHubStatus(hubId){
    for (let i = 0; i < this.customersData['hubs'].length; i++) {
      const hub = this.customersData['hubs'][i];
      if(hub.hubId === hubId) {
        const statusExists = hub['hubStatus']?true:false;
        let initialData = {
          reason: statusExists?hub['hubStatus']['reason']:'',
          requiredAction: statusExists?hub['hubStatus']['requiredAction']:'',
          lockHub: statusExists?(hub['hubStatus']['status']=='LOCKED'):false,
          blockHubFunctionality: statusExists?hub['hubStatus']['blockFunctionality']:false,
        }
        return initialData;
      }
    }
  }

  showToast(duration, messageTitle, messageContent) {
    this.toastrService.show(
      messageContent,
      messageTitle,
      { duration });
  }

  handleRepeaterGraphResponse(res, hubId) {
    var obj = {};
    obj[hubId] = {
      'cols': res.data['cols'],
      'rows': res.data['rows']
    }

    this.repeaterGraph.data = obj;
  }

  handlehealthGraphResponse(res, nodeId) {
    var finalData = res.finalData;

    var voltage = [];
    var temp = [];
    var rssi = [];
    var parentIds = [];
    var vt = [];
    var tt = [];
    var rt = [];
    var prt = [];


    finalData.forEach((dataArr) => {
      if (dataArr[1].hasOwnProperty("voltage")) {
        voltage.push(dataArr[1].voltage);
        // this.name === 'IWS_SC_DC_1' ? voltage.push((dataArr[1].voltage+3)/2) : voltage.push(dataArr[1].voltage);
        vt.push(new Date(dataArr[0] * 1000));
      }
      if (dataArr[1].hasOwnProperty("temp")) {
        temp.push(dataArr[1].temp);
        tt.push(new Date(dataArr[0] * 1000));
      }
      if (dataArr[1].hasOwnProperty("rssi")) {
        let rssiStr = dataArr[1].rssi;
        rssi.push(rssiStr);
        rt.push(new Date(dataArr[0] * 1000));
      }
      if(dataArr[1].hasOwnProperty("parentId")) {
        parentIds.push(dataArr[1].parentId);
        prt.push(new Date(dataArr[0] * 1000))
      }
    })


    var traceVol = {
      x: vt,
      y: voltage,
      name: 'voltage',
    }

    var traceTemp = {
      x: tt,
      y: temp,
      yaxis: 'y2',
      name: 'temperature',
    }

    var traceRssi = {
      x: rt,
      y: rssi,
      yaxis: 'y3',
      name: 'rssi',
    }

    var traceRepeater = {
      x: prt,
      y: parentIds,
      yaxis: 'y4',
      name: 'parentId',
    }

    var selectorOptions = {
      buttons: [{
        step: 'day',
        stepmode: 'backward',
        count: 1,
        label: '1d'
      }, {
        step: 'day',
        stepmode: 'backward',
        count: 6,
        label: '1week'
      }, {
        step: 'month',
        stepmode: 'backward',
        count: 6,
        label: '6m'
      }, {
        step: 'year',
        stepmode: 'todate',
        count: 1,
        label: 'YTD'
      }, {
        step: 'year',
        stepmode: 'backward',
        count: 1,
        label: '1y'
      }, {
        step: 'all',
      }],
    };

    this.graph[nodeId] = {}

    this.graph[nodeId]['data'] = [traceVol, traceTemp, traceRssi, traceRepeater];

    this.graph[nodeId]['layout'] = {
      title: "health status ",
      xaxis: {
        width: 800,
        rangeselector: selectorOptions,
        rangeslider: {},
        layout: 'category'
      },
      yaxis: {
        height: 500,
        title: "voltage"
      },
      yaxis2: {
        title: "temperature",
        side: 'right',
        anchor: 'x',
        overlaying: 'y',
      },
      yaxis3: {
        title: "rssi",
        anchor: 'free',
        overlaying: 'y',
        side: 'right',
        position: 0.95
      },
      yaxis4: {
        title: "parentId",
        anchor: 'free',
        overlaying: 'y',
        side: 'right',
      }
    }
  }

  handlehealthGraphResponseOld(response, nodeId) {
    var res = response.oldData;

    if(res.length == 0){
      return;
    }
    var finalDataVoltage = res.filter((item)=>{
      return item.name =="voltage"
    })[0];
    var finalDataRSSI = res.filter((item)=>{
      return item.name =="rssi"
    })[0];
    var finalDataTemp = res.filter((item)=>{
      return item.name =="temperature"
    })[0];


    var voltage = [];
    var temp = [];
    var rssi = [];
    var parentIds = [];
    var vt = [];
    var tt = [];
    var rt = [];
    var prt = [];


    if(finalDataVoltage.x) {
      for(const x of finalDataVoltage.x) {
        vt.push(new Date(x));
      }
    }
    if(finalDataVoltage.y) {
      for(const y of finalDataVoltage.y) {
        voltage.push(y+"");
      }
    }

    if(finalDataRSSI.x) {
      for(const x of finalDataRSSI.x) {
        rt.push(new Date(x));
      }
    }
    if(finalDataRSSI.y) {
      for(const y of finalDataRSSI.y) {
        rssi.push(y);
      }
    }

    if(finalDataTemp.x) {
      for(const x of finalDataTemp.x) {
        tt.push(new Date(x));
      }
    }
    if(finalDataTemp.y) {
      for(const y of finalDataTemp.y) {
        temp.push(y);
      }
    }

    // if(dataArr[1].hasOwnProperty("parentId")) {
    //   parentIds.push(dataArr[1].parentId);
    //   prt.push(new Date(dataArr[0] * 1000))
    // }



    var traceVol = {
      x: vt,
      y: voltage,
      name: 'voltage',
    }

    var traceTemp = {
      x: tt,
      y: temp,
      yaxis: 'y2',
      name: 'temperature',
    }

    var traceRssi = {
      x: rt,
      y: rssi,
      yaxis: 'y3',
      name: 'rssi',
    }

    var traceRepeater = {
      x: prt,
      y: parentIds,
      yaxis: 'y4',
      name: 'parentId',
    }

    var selectorOptions = {
      buttons: [{
        step: 'day',
        stepmode: 'backward',
        count: 1,
        label: '1d'
      }, {
        step: 'day',
        stepmode: 'backward',
        count: 6,
        label: '1week'
      }, {
        step: 'month',
        stepmode: 'backward',
        count: 6,
        label: '6m'
      }, {
        step: 'year',
        stepmode: 'todate',
        count: 1,
        label: 'YTD'
      }, {
        step: 'year',
        stepmode: 'backward',
        count: 1,
        label: '1y'
      }, {
        step: 'all',
      }],
    };

    this.graph[nodeId] = {}

    this.graph[nodeId]['data'] = [traceVol, traceTemp, traceRssi, traceRepeater];

    this.graph[nodeId]['layout'] = {
      title: "health status ",
      xaxis: {
        width: 800,
        rangeselector: selectorOptions,
        rangeslider: {},
        layout: 'category'
      },
      yaxis: {
        height: 500,
        title: "voltage"
      },
      yaxis2: {
        title: "temperature",
        side: 'right',
        anchor: 'x',
        overlaying: 'y',
      },
      yaxis3: {
        title: "rssi",
        anchor: 'free',
        overlaying: 'y',
        side: 'right',
        position: 0.95
      },
      yaxis4: {
        title: "parentId",
        anchor: 'free',
        overlaying: 'y',
        side: 'right',
      }
    }
  }

  showlocalEngagement = false;

  private data: TreeNode<FSEntry>[] = [
  ];

  //   _nodeType(nodeId) {
  //     for(var i=0;i<this.nodes.length;i++){
  //         if(this.nodes[i].shortAddress==nodeId)
  //             return this.nodes[i].nodeType;
  //     }
  // }

  criticalLogMsg(item) {

    console.log("criticalLogMsg log",item);
    

    if(!item.actionId)
      item.actionId = 0;

    if(!item.nodeId)
      item.nodeId = 0;

    var all_Nodes = releasedNodeTypes;
    var rebootCause = ["POWER_FAILURE", "LPDS_EXIT", "UnDefined", "CORE_RESET", "MCU_RESET", "WDT_RESET", "SOC_RESET", "HIBERNATE_EXIT", "ROUTER_PING_FAILED"];
    if (item.type == 'HUB_REBOOT') {
      var p = rebootCause[item.actionId];
      return 'Hub rebooted due to ' + p + ' (' + item.actionId + ')';
    }
    if (item.type == 'HUB_WIFI_UPDATED') {
      let msg = "";
      let otherData = item.otherData
      if(otherData == undefined) {
        return "Hub WiFi updated successfully";
      }
      if(otherData == "updated") {
        let actionId = item.actionId;
        let profileType = "Primary";
        if(actionId == 1) {
          profileType = "Secondary";
        }
        return "Hub WiFi updated successfully for " + profileType + " profile and is now connected to " + (item.dataId || "N/A");
      }else if(otherData == "clear") {
        let actionId = item.actionId;
        let profileType = "Primary";
        if(actionId == 1) {
          profileType = "Secondary";
        }else if(actionId == -1) {
          profileType = "Both Primary and Secondary";
        }
        return "Hub WiFi credentials cleared for " + profileType + " profile(s)";
      }else if(otherData == "swap") {
        return "Primary and Secondary WiFi Profiles are swapped successfully";
      }
      return msg
    }
    if(item.type == "HUB_WIFI_SLOT_CHANGED") {
      let slotName = ""
      if(item.actionId == 0) {
        slotName = "Primary"
      }else if(item.actionId == 1) {
        slotName = "Secondary"
      }
      return "HUB is now connected to network : " + (item.dataId || "N/A") + " (" + slotName + ")";
    }
    var k = all_Nodes[item.actionId];
    if (item.type == 'ADD_NODE')
      if(item.nodeType == "S_NODE") {
        let msg = "";
        let otherData = item.otherData
        if(otherData == "CREATING") {
          return "Virtual Node #"+item.nodeId + " (" + item["extraData"]["sFeatureDeviceType"] + ") is initiated for Creation"
        }else if(otherData == "CREATED") {
          return "Virtual Node #"+item.nodeId + " (" + item["extraData"]["sFeatureDeviceType"] + ") is Created successfully"
        }else if(otherData == "CREATE_FAILED") {
          return "Virtual Node #"+item.nodeId + " (" + item["extraData"]["sFeatureDeviceType"] + ") is Failed to Create"
        }
      }else {
        return k + ' with node id #' + item.nodeId + ' has been added';
      }
    if (item.type == 'DEL_NODE'){
      if(item.nodeType == "S_NODE") {
        let msg = "";
        let otherData = item.otherData
        if(otherData == "DELETING") {
          return "Virtual Node #"+item.nodeId + " (" + item["extraData"]["sFeatureDeviceType"] + ") is initiated for Deletion"
        }else if(otherData == "DELETED") {
          return "Virtual Node #"+item.nodeId + " (" + item["extraData"]["sFeatureDeviceType"] + ") is Deleted successfully"
        }else if(otherData == "DELETE_FAILED") {
          return "Virtual Node #"+item.nodeId + " (" + item["extraData"]["sFeatureDeviceType"] + ") is Failed to Delete"
        }
      }
      return k + ' with node id #' + item.nodeId + ' has been removed';
    }
    // var l=this._nodeType(item.nodeId);
    var l = "A device"
    if (item.type == 'FLUCTUATIONS' && item.actionId == 1 && item.nodeId != 0) {
      if (item.otherData) {
        return l + ' with node id #' + item.nodeId+ ', appID #'+(item.appId == undefined ? 0 : item.appId)  + ' came online due to ' + item.otherData;
      } else {
        return l + ' with node id #' + item.nodeId + ', appID #'+(item.appId == undefined ? 0 : item.appId) + ' came online';
      }
    }
    if (item.type == 'FLUCTUATIONS' && item.actionId == 0 && item.nodeId != 0) {
      if (item.otherData) {
        return l + ' with nodeID #' + item.nodeId + ', appID #'+(item.appId == undefined ? 0 : item.appId) + ' went offline due to ' + item.otherData;
      } else {
        return l + ' with node id #' + item.nodeId+ ', appID #'+(item.appId == undefined ? 0 : item.appId)  + ' went offline';
      }
    }

    if (item.type == 'FLUCTUATIONS' && item.actionId == 1 && item.nodeId == 0) {
      if (item.otherData) {
        return 'Hub came Online due to ' + item.otherData;
      } else {
        return 'Hub came Online';
      }
    }

    if (item.type == 'FLUCTUATIONS' && item.actionId == 0 && item.nodeId == 0) {
      if (item.otherData) {
        return 'Hub went Offline due to ' + item.otherData;
      } else {
        return 'Hub went Offline';
      }
    }
    var isRuleFailure = item.type == 'FAILURE_RULE';
    var isFailure = item.type == 'FAILURE';
    if (isFailure || isRuleFailure) {
      if(isFailure){
        console.log("activityLog failure",item);
      }
      
      if(isFailure && item.otherData != undefined && item.otherData.includes("ir_cmd:")) {
        return "Failed to "+item.otherData.replace(/ir_cmd:/g,"")+ " on node# " + item.nodeId
      }
      var subject = isRuleFailure ? "Rule #" + item.otherData + " has" : "User has";
      var action = ((item.actionId == 0) ? "turn off" : ((item.actionId == 1) ? "turn on" : item.actionId));
      var reason = (item.performedBy == "CH_COMM_FAIL") ? " since HUB is not reachable" : (item.performedBy == "HN_COMM_FAIL") ? " since Node is not reachable" : "";
      return subject + " failed to " + action + " node# " + item.nodeId + " appId: " + (item.appId == undefined ? 0 : item.appId) + reason;
    }

    if (item.type == "ALERT_RSSI") {
      return "Weak signal Alert for nodeId: " + item.nodeId;
    }
    if (item.type == "ALERT_BATTERY") {
      return "Low signal Alert for nodeId: " + item.nodeId;
    }
    if (item.type == "HUB_OTA") {
      let extraData = item.extraData;
      if(extraData && extraData["applicationCapability"] != undefined) {
        return "HUB updated to firmware version: " + item.otherData + " and Application Capability : "+extraData["applicationCapability"];
      }
      return "HUB updated to firmware version: " + item.otherData;
    }

    if (item.type == "NODE_OTA") {
      return "Node with ID : " + item.nodeId + " was updated to firmware version: " + (item.dataId ?? item.otherData) + " and Image ID : "+ (item.otherData ?? "N/A");
    }

    return item.type + ' ' + item.actionId;

  }

  isFetchingAccessList = false;
  fetchAccessList(hubId,hub){
    hub.finalAcls = [];
    this.isFetchingAccessList = true;
    this.http.get(this.env.apiUrl + "/api/hubTransfer/accessList?hubId="+hubId)
        .subscribe(response=>{
          console.log(response)
          this.isFetchingAccessList = false;
          hub.finalAcls = response["finalAcls"];
        },err=>{
          console.log(err);
          this.showToast(3000,"HUB Access List","Failed to get Access List for HUB.");
          this.isFetchingAccessList = false;
        })
  }

  changeHubRange(mode,hubId){
    const command=consoleCommands['changeHubRange']['value'];
    this.http.post(this.env.apiUrl + "/api/sendCommand",{ command: command + " "+mode, hubId: hubId })
        .subscribe(response=>{
          console.log(response)
          this.showToast(3000,"HUB Range Mode","Successfully changed HUB Range Mode.");
        },err=>{
          console.log(err);
          this.showToast(3000,"HUB Range Mode","Failed to change HUB Range Mode.");
        })
  }

  changeNodeRange(mode,shortId,hubId){
    let nodeId=parseInt(shortId+"").toString(16);
    if(nodeId.length<2){
            nodeId="0"+nodeId;
    }
    const command=consoleCommands['changeNodeRange']['value'];
    let finalCommand = command+ " "+ nodeId+ " 01 "+mode;
    console.log("changeNodeRange finalCommand",finalCommand);
    console.log("changeNodeRange nodeId",nodeId);
    this.http.post(this.env.apiUrl + "/api/sendCommand",{ command: finalCommand, hubId: hubId })
        .subscribe(response=>{
          console.log(response)
          this.showToast(3000,"Node Range Mode","Successfully changed Node Range Mode.");
        },err=>{
          console.log(err);
          this.showToast(3000,"Node Range Mode","Failed to change Node Range Mode.");
        })
  }

  sendCommand(form: NgForm, hubId) {
    console.log(form.value);
    if (form.invalid) return;

    this.http.post(this.env.apiUrl + "/api/sendCommand", { command: form.value.command, hubId: hubId })
      .subscribe(response => {
        console.log(response);
      }, err => {
        console.log(err);
      })

  }

  getRssiWarningLevel(rssi) {
    if (rssi == null)
      return "primary";
    if (rssi >= -30) {
      return "warning";
    } else if (rssi > -85) {
      return "success";
    } else if (rssi > -90) {
      return "primary";
    } else if (rssi > -95) {
      return "warning";
    } else {
      return "danger";
    }
  }

  getHubRssiWarningLevel(rssi) {
    if (rssi == null) {
      return "danger";
    }

    if (rssi >= -60) {
      return "success"
    } else if (rssi >= -65) {
      return "warning"
    } else {
      return "danger"
    }
  }

  ngOnDestroy() {
    console.log("Destroyed user")
    this.menuServiceSub.unsubscribe();
    this.searchSubscription.unsubscribe();
    this.searchSubscriptionSmall.unsubscribe();
  }

  getNodeName(obj) {
    // console.log(obj.name)
    return obj?obj.name:'';
  }

  scroll(id) {
    console.log(`scrolling to ${id}`);
    let el = document.getElementById(id);
    if(el != null) {
      el.scrollIntoView({ block: "center", inline: "nearest", behavior: 'smooth' });
    }
  }

}
